import { useMemo } from "react";
import MoreModal from ".";
import { useVisible } from "../../../../../../../../utils/hooks/useVisible";

export const useMoreModal = () => {
    const { open, close, visible, selected } = useVisible();

    const modal = useMemo(() => {
        return (
            <MoreModal
                open={visible}
                close={close}
                selected={selected}
            />
        );
    }, [visible, close, selected]);

    return { open, modal };
}